import { requiredIf } from 'vuelidate/lib/validators';

import { PaymentType } from '@/models/org-payment-method';
import { hasAccountFields } from '@/models/org-payment-method';
import { hasPartnerPlan, OrdwayPlan } from '@/models/ordway';
import { Constants } from './Constants';

const validFarmSourceNumber = (value: string) => /^[0-9]{9}$/.test(value);

const validRuralCoNumber = (value: string) => /(^[0-9]{4,5}$)|(^[RM][0-9]{7,8}$)/.test(value);

export const validDirectDebitNumber = (value: string) =>
	/^[0-9]{2}-[0-9]{4}-[0-9]{7}-[0-9]{2,3}$/.test(value);

export const validAccountNumber = (paymentType: PaymentType) => (value: string): boolean => {
	switch (paymentType) {
		case 'ruralCo':
			return validRuralCoNumber(value);
		case 'farmSource':
			return validFarmSourceNumber(value);
		case 'directDebit':
			return validDirectDebitNumber(value);
		case 'directInvoice':
			return true;
		default:
			return true;
	}
};

export const accountFieldValidators = (paymentType: PaymentType) => ({
	accountNumber: {
		validAccountNumber: validAccountNumber(paymentType),
	},
	accountName: {
		required: requiredIf(() => hasAccountFields(paymentType)),
	},
});

export const partnerPlanValidator = (directPlan: OrdwayPlan) => hasPartnerPlan(directPlan);

/**
 * Bounds inclusive.
 */
export const numberInputValid = (params: {
	field: number | string | null;
	min: number;
	max: number | null;
}): boolean => {
	// https://bootstrap-vue.org/docs/components/form-input#v-model-modifiers
	// a number form input will return empty string when empty, number otherwise
	const { field, min, max } = params;
	return typeof field === 'number' && field >= min && (max !== null ? field <= max : true);
};

export const isWaterMeterEntity = (entityType?: string): boolean => {
	return (
		entityType === Constants.ENTITY_TYPE_WATER_METER ||
		entityType === Constants.ENTITY_TYPE_WATER_MONITOR
	);
};
